import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#939393";
function DEEZ({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  fillRule="evenodd" d="M10.28 14.895a539 539 0 013.906-2.403c1.293-.79 1.293-.79 1.27-.868-.022-.094-8.025-4.956-8.107-5.005q-.228-.135-.451-.277c.147-.102.433-.297.775-.53l.832-.562.571.342c.705.422 8.446 5.169 9.53 5.845a845 845 0 01-4.118 2.435l-4.187 2.468a27 27 0 01-.015-.656 35 35 0 01-.005-.788zm-1.776-4.722c.139.082.379.227.675.411l.771.479.017 1.447c.048 4.183.048 4.183.11 4.225l.04.028.045-.016c.022-.007.03-.01 8.153-4.802l.435-.256-.143 2.012-.053.03a3819 3819 0 01-10.041 5.748c-.004-.524-.008-2.314-.009-4.647zM6.75 18.6l.019-11.975.29.172c.235.136 1.813 1.098 3.596 2.189q1.915 1.173 3.835 2.338l.536.323-1.773 1.084-.354-.206q-1.065-.643-2.122-1.299-1.032-.639-2.07-1.266l-.49-.285-.003 5.077-.005 4.749-.681-.42z" clipRule="evenodd" /></Svg>;
}
DEEZ.DefaultColor = DefaultColor;
export default DEEZ;